"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginIdpLinkEmail = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Template_1 = require("./Template");
var i18n_1 = require("../i18n");
exports.LoginIdpLinkEmail = (0, react_1.memo)(function (_a) {
    var kcContext = _a.kcContext, props = __rest(_a, ["kcContext"]);
    var url = kcContext.url, realm = kcContext.realm, brokerContext = kcContext.brokerContext, idpAlias = kcContext.idpAlias;
    var msg = (0, i18n_1.getMsg)(kcContext).msg;
    return ((0, jsx_runtime_1.jsx)(Template_1.Template, __assign({}, __assign({ kcContext: kcContext }, props), { doFetchDefaultThemeResources: true, headerNode: msg("emailLinkIdpTitle", idpAlias), formNode: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("p", __assign({ id: "instruction1", className: "instruction" }, { children: msg("emailLinkIdp1", idpAlias, brokerContext.username, realm.displayName) })), (0, jsx_runtime_1.jsxs)("p", __assign({ id: "instruction2", className: "instruction" }, { children: [msg("emailLinkIdp2"), " ", (0, jsx_runtime_1.jsx)("a", __assign({ href: url.loginAction }, { children: msg("doClickHere") })), " ", msg("emailLinkIdp3")] })), (0, jsx_runtime_1.jsxs)("p", __assign({ id: "instruction3", className: "instruction" }, { children: [msg("emailLinkIdp4"), " ", (0, jsx_runtime_1.jsx)("a", __assign({ href: url.loginAction }, { children: msg("doClickHere") })), " ", msg("emailLinkIdp5")] }))] }) })));
});
//# sourceMappingURL=LoginIdpLinkEmail.js.map